<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Parâmetros de Reserva
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Máximo de dias
                            permitidos para reserva imediata:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="reserveVehiclesParameters.max_days"
                            placeholder
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span>
                            Após {{ reserveVehiclesParameters.max_days }} dias
                            redirecionar a reserva para o status:
                          </label>
                          <select
                            v-model="
                              reserveVehiclesParameters.reserve_status_id
                            "
                            class="form-control"
                          >
                            <option
                              v-for="rs in reserveVehiclesStatus"
                              :value="rs.id"
                              :key="rs.id"
                              >{{ rs.title }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Mínimo de horas
                            entre a data de retirada e de devolução:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="reserveVehiclesParameters.minimal_hours"
                            placeholder
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Mínimo de horas
                            entre a reserva do mesmo veículo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="reserveVehiclesParameters.period_reserve"
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="block text-right">
                <a class="btn btn-add" @click="saveParameters">
                  Salvar Parâmetros
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Parâmetros de Checkout
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Mínimo de horas para
                            realizar checkout antecipado:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="
                              reserveVehiclesParameters.minimal_hour_to_checkout
                            "
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="block text-right">
                <a class="btn btn-add" @click="saveParameters">
                  Salvar Parâmetros
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Cancelamento automático de reservas
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span>
                            Cancelar reservas não retiradas após
                            {{
                              reserveVehiclesParameters.maximal_hours_cancel
                            }}
                            hora(s):
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="
                              reserveVehiclesParameters.maximal_hours_cancel
                            "
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="block text-right">
                <a class="btn btn-add" @click="saveParameters">
                  Salvar Parâmetros
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Parâmetros de Rodízio
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Desativar rodízio a
                            partir de:
                          </label>
                          <input
                            type="datetime-local"
                            step="2"
                            class="form-control"
                            v-model="
                              reserveVehiclesParameters.inative_caster_ini
                            "
                            placeholder
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> até:
                          </label>
                          <input
                            type="datetime-local"
                            step="2"
                            class="form-control"
                            v-model="
                              reserveVehiclesParameters.inative_caster_fin
                            "
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="block text-right">
                <a class="btn btn-add" @click="saveParameters">
                  Salvar Parâmetros
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>

          <!-- <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Status de Reservas
                                <span class="required_fields"><span class="required">*</span> Campos obrigatórios</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form id="form">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="description"><span class="required">*</span> Descrição:</label>
                                                    <input type="text" class='form-control' v-model="reserveNewStatus.title" placeholder="Novo status...">

                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-add btn-block mt-4" @click="save">Cadastrar Novo Status</button>
                                            </div>
										</div>
                                    </form>
                                </div>
                            </div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col" style="width: 30%">Descrição</th>
                                                <th scope="col">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="r in reserveVehiclesStatus" :key="r.id">
                                                <td>{{ r.title }}</td>
                                                <td><button type="button"  @click="destroy(r.id)" class="btn btn-crud delete" data-tooltip="tooltip" title="Excluir"><i class="far fa-trash-alt"></i></button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data() {
    return {
      reserveVehiclesStatus: [],
      reserveNewStatus: {
        title: ""
      },
      reserveVehiclesParameters: {
        id: 1,
        max_days: 0,
        reserve_status_id: 0,
        maximal_hours_cancel: 1,
        period_reserve: 1
      }
    };
  },
  computed: {},
  methods: {
    makeFormData: function() {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.reserveNewStatus.title);

      return fd;
    },
    save: function() {
      const self = this;
      let api = self.$store.state.api + "reserveVehiclesStatus";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then(response => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.getReserveVehiclesStatus();
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveParameters: function() {
      const self = this;
      let api = self.$store.state.api + "reserveVehiclesParameters/1/";

      let fd = self.makeFormData();

      fd.append("_method", "PUT");
      fd.append("max_days", this.reserveVehiclesParameters.max_days);
      fd.append(
        "reserve_status_id",
        this.reserveVehiclesParameters.reserve_status_id
      );
      fd.append(
        "inative_caster_ini",
        this.reserveVehiclesParameters.inative_caster_ini
      );
      fd.append(
        "inative_caster_fin",
        this.reserveVehiclesParameters.inative_caster_fin
      );
      fd.append(
        "minimal_hour_to_checkout",
        this.reserveVehiclesParameters.minimal_hour_to_checkout
      );
      fd.append("minimal_hours", this.reserveVehiclesParameters.minimal_hours);
      fd.append(
        "maximal_hours_cancel",
        this.reserveVehiclesParameters.maximal_hours_cancel
      );
      fd.append(
        "period_reserve",
        this.reserveVehiclesParameters.period_reserve
      );

      self.$http
        .post(api, fd)
        .then(response => {
          self.$message(
            "Sucesso",
            `Parâmetros alterados com sucesso`,
            "success"
          );
          self.getReserveVehiclesStatus();
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReserveVehiclesStatus: function() {
      const self = this;
      const api = self.$store.state.api + "reserveVehiclesStatus/";

      self.$http
        .get(api)
        .then(response => {
          self.reserveVehiclesStatus = response.data.data;
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReserveVehiclesParameters: function() {
      const self = this;
      const api = self.$store.state.api + "reserveVehiclesParameters/1";

      self.$http
        .get(api)
        .then(response => {
          self.reserveVehiclesParameters = response.data.data[0];
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    destroy(id) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger"
          },
          confirm: {
            text: "Sim",
            value: "confirm"
          }
        }
      }).then(value => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            const api = self.$store.state.api + "reserveVehiclesStatus/" + id;

            self.$http
              .delete(api)

              .then(response => {
                swal("Sucesso", "Registro excluído com sucesso!", "success");
                self.getReserveVehiclesStatus();
              });

            break;
        }
      });
    }
  },
  mounted: function() {
    const self = this;
    self.getReserveVehiclesStatus();
    self.getReserveVehiclesParameters();
  },
  components: {
    BaseCrud
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Parameters/ReserveVehicles.vue